import { Slider } from '@parship/psg-slider';

export default class SubNavigation extends Slider {
	public constructor(target: HTMLElement) {
		super({ target, itemsPerView: -1 });

		if (this.overflow) {
			this.items.forEach((item: HTMLElement, index: number) => {
				if (
					item.classList.contains('current-menu-item') ||
					item.classList.contains('current-menu-parent')
				) {
					this.currentItem = index;
					this.scrollToCurrentItem('auto');
				}
			});
		}
	}
}
